import { getLesson, updateLessonPlane } from "./api";
import { lessonSlice } from './reducer'

const {
    updateDetailId
} = lessonSlice.actions

export {
    getLesson,
    updateLessonPlane,
    updateDetailId
}